import React from 'react';
import classnames from 'classnames';

class RadioCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(e) {
    const target = e.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.props.onChange(value);

    this.setState({
      [name]: value
    });
  }

  render() {
    return (
    <div className={classnames('control simple-checkbox', {active: this.state.checked})}>
      <input
        id="checkbox"
        name="checked"
        type="checkbox"
        checked={this.state.checked}
        onChange={this.handleInputChange}
      />
      <label htmlFor="checkbox">{this.props.label}</label>
    </div>
    );
	}
}

RadioCheckbox.defaultProps = {
	default: null,
  onChange: function(){}
};

RadioCheckbox.propTypes = {
  onChange: React.PropTypes.func.isRequired,
  label: React.PropTypes.string.isRequired
};


export default RadioCheckbox;



// WEBPACK FOOTER //
// ./src/components/forms/RadioCheckbox.js